import saveCustomConfig from 'app/shared/CustomConfig/sagas/saveCustomConfig';
import retrieveOrgTableConfig from 'app/shared/CustomConfig/sagas/retrieveOrgTableConfig';

const sagaRegistry = [saveCustomConfig, retrieveOrgTableConfig];

export default sagaRegistry;
